import React, {Component, useState} from "react";
import PropTypes from "prop-types";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Columns } from "react-bulma-components";
import { Box } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import AvailablePanel from "./AvailablePanel";
import RentalsPanel from "./RentalsPanel";
import VehicleFinder from "./VehicleFinder";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getVehicleTypesData} from "../../state/selectors";

// export default function VehicleFinderSection(props) {
//   const dispatch = useDispatch();
//   let vehicleTypes = useSelector(getVehicleTypesData);
//   let dataFresh = useSelector(getDataFresh);
//   const [searchText, setSearchText] = useState("");
//   const [currentSearch, setCurrentSearch] = useState("");
//   const [filters, setFilters] = useState({});
//
// }
export default class VehicleFinderSection extends Component {

  static propTypes = {
    endpoint: PropTypes.string.isRequired
  };
  state = {
    vehicle: this.props.vehicle,
    searchData: [],
    isLoading: false,
    type: "",
    availableVehicles: []
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSearch = e => {};

  handleVehicleSelect = e => {
    console.log("select veh 1")
    this.props.selectVehicle(e[0]);
    this.typeahead.getInstance().clear();
    // this.props.vehicleUpdate(e[0]);
  };

  updateAvailableVehicles = vehicles => {
    this.setState({ availableVehicles: vehicles });
  };

  render() {
    return (
      <Box>
        <Columns>
          <Columns.Column size="one-fifth">
            <Heading>Vehicle Finder</Heading>
            <VehicleFinder
              vehicle={{}}
              endpoint={this.props.endpoint}
              updateAvailableVehicles={this.updateAvailableVehicles}
              selectVehicle={this.props.selectVehicle}
              startDate={this.props.startDate}
              finishDate={this.props.finishDate}
            />
          </Columns.Column>
          <Columns.Column>
            <Heading>Available</Heading>
            <AvailablePanel
              vehicles={this.state.availableVehicles}
              selectVehicle={this.props.selectVehicle}
            />
          </Columns.Column>
          <Columns.Column>
            <Heading>Other Rentals</Heading>
            <RentalsPanel
              onHireDate={this.props.onHireDate}
              finishDate={this.props.finishDate}
              endpoint={`${this.props.endpoint}rentals`}
            />
          </Columns.Column>
        </Columns>
      </Box>
    );
  }
}
